import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStethoscope = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.436 9.81416C17.114 10.4922 17.114 11.5914 16.436 12.2694C15.758 12.9474 14.6588 12.9474 13.9808 12.2694C13.3028 11.5914 13.3028 10.4922 13.9808 9.81416C14.6588 9.13616 15.758 9.13616 16.436 9.81416",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83332 3.75H4.44443C3.67707 3.75 3.05554 4.37153 3.05554 5.13889V7.91668C3.05554 10.2181 4.92082 12.0834 7.22221 12.0834C9.5236 12.0834 11.3889 10.2181 11.3889 7.91668V5.13889C11.3889 4.37153 10.7673 3.75 9.99999 3.75H8.6111",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2084 12.7778V12.9514C15.2084 15.157 13.4209 16.9445 11.2153 16.9445C9.00979 16.9445 7.22229 15.157 7.22229 12.9514V12.0834",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83331 3.05566V4.44456",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.61114 3.05566V4.44456",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgStethoscope;
